import {logUserOut} from "src/containers/permissions/permissionFunctions";
import {goHome} from "../containers/foundation/foundationFunctions";

export const menu = [
    {label:"Home","click":()=>goHome(),"id":"homeButton",icon:"images/home-icon.png"},
    {label:"About Us","module":"components/TDP/FrontSliders/TDPSimple",id:"aboutus",icon:"images/about-us-icon.png"},
];

export const notLoggedInMenu = [
    {label:"Sign Up","module":"components/TDP/SignUp/TDPSignUp",id:"signup",icon:"images/signup-icon.png"},
    {label:"Login","module":"components/TDP/LoginFormTDP",id:"login",icon:"images/login-icon.png"},

];

export const loggedInMenu = [
    {label:"My Account","module": "components/gameTime/MyAccount",id:"myAccountButton",icon:"images/signup-icon.png"},
    {label:"My Friends","module": "components/gameTimeMyFriends/MyFriends",id:"myFriendsButton",icon:"images/my-friends-icon.png"},
    {label:"Use As","module":"components/TDP/PlayAs",id:"useAsButton",icon:"images/use-as-icon.png"},
    {label:"Logout","click":()=> logUserOut(),icon:"images/logout-icon.png"}
];

export const endMenu = [
    {label:"FAQs","module":"components/TDP/content/FAQs",id:"faq",icon:"images/faq-icon.png"},
    {label:"Contact","module":"components/TDP/SignUp/TDPMoreInfo",id:"contact",icon:"images/contact-icon.png"},
    {label:"DANCE PARTY","module":"components/games/DanceParty/DanceParty",id:"danceparty",icon:"images/dance-party-icon.png"}
    //{label:"Newsletter","module":"components/TDP/newsletter/SubscribeNewsletter",id:"newsletter"},

];
//{label:"Events","module":"components/TDP/RSVP/TDPEvents",id:"events",icon:"images/events-icon.png"},
//{label:"Pay","module":"components/Stripe/StripeWrapper",id:"Pay"},

//    {label:"What to do?","module":"components/TDP/WhatToDo"}
//{label:"Contact Us","module":"components/TDP/TDPContactPage"},
//
//
